import { create } from 'zustand'

import { queryMaterial } from '@/lib/api'
import type { MaterialQueryResponse } from '@/types/material'

type Status = 'idle' | 'loading' | 'error'

interface MaterialState {
  text: string
  status: Status
  error?: string
  data?: MaterialQueryResponse
  setText: (text: string) => void
  run: (text?: string) => Promise<void>
  reset: () => void
}

let abort: AbortController | null = null

export const useMaterialStore = create<MaterialState>((set, get) => ({
  text: '',
  status: 'idle',
  error: undefined,
  data: undefined,

  setText(text) {
    set({ text })
  },

  async run(text) {
    const input = (text ?? get().text).trim()
    if (!input || get().status === 'loading') return
    set({ text: input, status: 'loading', error: undefined })

    abort?.abort()
    abort = new AbortController()
    try {
      const data = await queryMaterial(input, abort.signal)
      set({ data, status: 'idle' })
    } catch (err) {
      const aborted = (err as Error).name === 'AbortError'
      set({ status: aborted ? 'idle' : 'error', error: aborted ? undefined : (err as Error).message })
    } finally {
      abort = null
    }
  },

  reset() {
    abort?.abort()
    set({ text: '', status: 'idle', error: undefined, data: undefined })
  },
}))
